import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.primary};

  svg {
    height: 2.5rem;
    flex-shrink: 0;
    margin-right: ${({ theme }) => theme.spacer * 2}px;
  }
  .message {
    text-align: left;
    p:last-child {
      margin-bottom: 0;
    }
  }
`;

const Base = ({ className, Svg, label }) => {
  const classes = ["Base"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")}>
      <Svg />
      <ReactMarkdown className="message">{label}</ReactMarkdown>
    </Wrapper>
  );
};

Base.displayName = "Base";

Base.propTypes = {
  className: PropTypes.string,
  Svg: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
};

Base.defaultProps = {
  className: null,
};

export default Base;
